import React, { useEffect } from "react";
import "../css/HelpPage.css";
import GettingStartedIcon from "../assets/icons/getting-started.svg";
import MyAccountIcon from "../assets/icons/my-account.svg";
import DataPrivacyIcon from "../assets/icons/data&privacy.svg";
import TermsServicesIcon from "../assets/icons/terms&services.svg";
import SubscriptionBillingIcon from "../assets/icons/subscription&billing.svg";
import FAQIcon from "../assets/icons/FAQ.svg";
import QIcon from "../assets/UserIcons/GethelpIconsQuestion.svg";
import { branding } from "../utils/branding";
import { useNavigate } from "react-router-dom";

const HelpPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = branding("Zerobox | Help & Support");
  }, []);
  const helpCards = [
    {
      title: "Getting Started",
      desc: branding(
        "Learn how to set up ZeroBox, explore AI chat modes, and start your first private or online session with ease."
      ),
      icon: GettingStartedIcon,
      link: "#/help/getting-started",
    },
    {
      title: "My Account",
      desc: branding(
        "Manage your ZeroBox account — update your profile, change settings, or control your privacy preferences."
      ),
      icon: MyAccountIcon,
      link: "#/help/my-account",
    },
    {
      title: "Data & Privacy",
      desc: branding(
        "Understand how ZeroBox protects your conversations, handles data locally or online, and gives you full control of your information."
      ),
      icon: DataPrivacyIcon,
      link: "#/help/data-privacy",
    },
    {
      title: "Terms of Service",
      desc: branding(
        "Read the legal terms that govern your use of ZeroBox and how we ensure transparency, fairness, and accountability."
      ),
      icon: TermsServicesIcon,
      link: "#/terms",
    },
    {
      title: "Subscription & Billing",
      desc: branding(
        "Get details about free and premium plans, billing cycles, and how to upgrade or cancel your ZeroBox subscription."
      ),
      icon: SubscriptionBillingIcon,
      link: "#/help/subscription-billing",
    },
    {
      title: "FAQs",
      desc: branding(
        "Find quick answers to common questions about ZeroBox features, troubleshooting, and AI privacy controls."
      ),
      icon: FAQIcon,
      link: "#/help/faq",
    },
  ];

  return (
    <div className="help-container py-2 py-sm-3 py-md-5 px-4" >
      {/* Question Mark Section */}
      {/* <div className="mb-0 mb-sm-1 mb-md-2   text-right ">
        <img
          src={QIcon}
          style={{ height: "30px", width: "30px", cursor: "pointer" }}
          className="icon-image"
          onClick={() => navigate("/user/getHelpPageInfo")}
        />
      </div> */}
      <h1 className="help-title">{branding("Need Help with ZeroBox?")}</h1>
      <p className="help-subtitle">
        Find answers, guides, and resources to make the most of your AI Privacy
        Chatbot experience.
      </p>

      {/* Search Bar */}
      <div className="search-box custom-search-group">
        <span className="search-icon">
          <i className="bi bi-search"></i>
        </span>
        <input type="text" placeholder="Search for help topics..." />
      </div>

      {/* Help Cards */}
      <div className="help-grid">
        {helpCards.map((card, index) => (
          <div className="help-card" key={index}>
            <div className="help-icon">
              <img className="icon-image1" src={card.icon} alt={card.title} />
            </div>
            <h3>{card.title}</h3>
            <p>{card.desc}</p>
            <a href={card.link} className="learn-link">
              Learn More
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HelpPage;
